export const COLORS = {
  webIcon: "#4067BA",
  closeIcon: "#7F7F7F",
  warning: "#D12A11",
};
